<template>
	<div class="log">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0" v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.outer_id" placeholder="库存编码"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="outer_id" label="库存编码" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="quantity" label="库存" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="err_msg" label="错误信息" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="同步时间" align="center" header-align="center" min-width="70px">
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'skulog',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					outer_id: "",
					mydate: []
				}
			}
		},
		
		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					outer_id: "",
					mydate: []
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;
				obj.shop_id = this.$route.query.shop_id;
				obj.goods_id = this.$route.query.goods_id;
				
				this.$axios.post('api/user/pdd_sku_log', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.log {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
</style>


// WEBPACK FOOTER //
// src/components/pdd/skulog.vue